export default "/images/a2b0eecbb46b0a8b41a6c8b46017b915.avif";